/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter API — Teams
 * OpenAPI спецификация для управления командами (teams). Самодостаточный файл для генерации и документации. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@hr-recruiter.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AddUserToTeamRequest
 */
export interface AddUserToTeamRequest {
    /**
     * ID пользователя для добавления в команду
     * @type {number}
     * @memberof AddUserToTeamRequest
     */
    'userId': number;
}
/**
 * Стандартный ответ об ошибке
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * Сообщение об ошибке
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * Список ошибок валидации
     * @type {Array<string>}
     * @memberof ErrorResponse
     */
    'errors'?: Array<string>;
}
/**
 * Базовый класс для всех пагинированных ответов
 * @export
 * @interface PaginatedResponse
 */
export interface PaginatedResponse {
    /**
     * Список элементов на текущей странице
     * @type {Array<object>}
     * @memberof PaginatedResponse
     */
    'content': Array<object>;
    /**
     * Общее количество элементов
     * @type {number}
     * @memberof PaginatedResponse
     */
    'totalElements': number;
    /**
     * Общее количество страниц
     * @type {number}
     * @memberof PaginatedResponse
     */
    'totalPages': number;
    /**
     * Номер текущей страницы (начиная с 0)
     * @type {number}
     * @memberof PaginatedResponse
     */
    'number': number;
    /**
     * Размер страницы
     * @type {number}
     * @memberof PaginatedResponse
     */
    'size': number;
}
/**
 * Модель команды
 * @export
 * @interface Team
 */
export interface Team {
    /**
     * Уникальный идентификатор команды
     * @type {number}
     * @memberof Team
     */
    'id': number;
    /**
     * Название команды
     * @type {string}
     * @memberof Team
     */
    'name': string;
    /**
     * Описание команды
     * @type {string}
     * @memberof Team
     */
    'description'?: string | null;
    /**
     * ID владельца команды
     * @type {number}
     * @memberof Team
     */
    'owner': number;
}
/**
 * 
 * @export
 * @interface TeamCreateRequest
 */
export interface TeamCreateRequest {
    /**
     * Название команды
     * @type {string}
     * @memberof TeamCreateRequest
     */
    'name': string;
    /**
     * Описание команды
     * @type {string}
     * @memberof TeamCreateRequest
     */
    'description'?: string | null;
    /**
     * ID владельца команды
     * @type {number}
     * @memberof TeamCreateRequest
     */
    'ownerId': number;
}
/**
 * 
 * @export
 * @interface TeamPatchRequest
 */
export interface TeamPatchRequest {
    /**
     * Новое название команды
     * @type {string}
     * @memberof TeamPatchRequest
     */
    'name'?: string;
    /**
     * Новое описание команды
     * @type {string}
     * @memberof TeamPatchRequest
     */
    'description'?: string | null;
    /**
     * ID нового владельца команды
     * @type {number}
     * @memberof TeamPatchRequest
     */
    'ownerId': number;
}
/**
 * 
 * @export
 * @interface UserSummary
 */
export interface UserSummary {
    /**
     * ID пользователя
     * @type {number}
     * @memberof UserSummary
     */
    'id': number;
    /**
     * Имя пользователя
     * @type {string}
     * @memberof UserSummary
     */
    'firstName': string;
    /**
     * Фамилия пользователя
     * @type {string}
     * @memberof UserSummary
     */
    'lastName': string;
    /**
     * Email пользователя
     * @type {string}
     * @memberof UserSummary
     */
    'email': string;
    /**
     * Роль пользователя
     * @type {string}
     * @memberof UserSummary
     */
    'role': UserSummaryRole;
}

export const UserSummaryRole = {
    ADMIN: 'ADMIN',
    RECRUITER: 'RECRUITER',
    SUPER_ADMIN: 'SUPER_ADMIN'
} as const;

export type UserSummaryRole = typeof UserSummaryRole[keyof typeof UserSummaryRole];


/**
 * TeamsApi - axios parameter creator
 * @export
 */
export const TeamsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Добавляет пользователя в команду
         * @summary Добавить пользователя в команду
         * @param {number} id ID команды
         * @param {AddUserToTeamRequest} addUserToTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserToTeam: async (id: number, addUserToTeamRequest: AddUserToTeamRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addUserToTeam', 'id', id)
            // verify required parameter 'addUserToTeamRequest' is not null or undefined
            assertParamExists('addUserToTeam', 'addUserToTeamRequest', addUserToTeamRequest)
            const localVarPath = `/teams/{id}/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addUserToTeamRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Создать команду в своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Создать команду
         * @param {TeamCreateRequest} teamCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam: async (teamCreateRequest: TeamCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamCreateRequest' is not null or undefined
            assertParamExists('createTeam', 'teamCreateRequest', teamCreateRequest)
            const localVarPath = `/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Удалить команду своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Удалить команду
         * @param {number} id ID команды
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTeam', 'id', id)
            const localVarPath = `/teams/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить информацию о команде своей компании по ID. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить команду по ID
         * @param {number} id ID команды
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeam', 'id', id)
            const localVarPath = `/teams/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получение списка всех пользователей команды, в которой состоит указанный пользователь. Доступен только для роли: admin. Возвращает основную информацию о пользователях: имя, фамилия, почта, роль. 
         * @summary Получить список пользователей команды по ID пользователя
         * @param {number} userId ID пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamUsersByUserId: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getTeamUsersByUserId', 'userId', userId)
            const localVarPath = `/users/{userId}/team-members`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получение списка всех пользователей команды с основной информацией. Доступен только для роли: admin. Возвращает основную информацию о пользователях: имя, фамилия, почта, роль. 
         * @summary Получить список пользователей команды
         * @param {number} id ID команды
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamUsersList: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeamUsersList', 'id', id)
            const localVarPath = `/teams/{id}/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить список команд своей компании с возможностью фильтрации и пагинации. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить список команд
         * @param {string} [search] Поиск по названию или описанию команды
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeams: async (search?: string, page?: number, size?: number, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Обновить информацию о команде своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Обновить команду
         * @param {number} id ID команды
         * @param {TeamPatchRequest} teamPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTeam: async (id: number, teamPatchRequest: TeamPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchTeam', 'id', id)
            // verify required parameter 'teamPatchRequest' is not null or undefined
            assertParamExists('patchTeam', 'teamPatchRequest', teamPatchRequest)
            const localVarPath = `/teams/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Удаляет пользователя из команды
         * @summary Удалить пользователя из команды
         * @param {number} id ID команды
         * @param {number} userId ID пользователя для удаления из команды
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromTeam: async (id: number, userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeUserFromTeam', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeUserFromTeam', 'userId', userId)
            const localVarPath = `/teams/{id}/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamsApi - functional programming interface
 * @export
 */
export const TeamsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamsApiAxiosParamCreator(configuration)
    return {
        /**
         * Добавляет пользователя в команду
         * @summary Добавить пользователя в команду
         * @param {number} id ID команды
         * @param {AddUserToTeamRequest} addUserToTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUserToTeam(id: number, addUserToTeamRequest: AddUserToTeamRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUserToTeam(id, addUserToTeamRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.addUserToTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Создать команду в своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Создать команду
         * @param {TeamCreateRequest} teamCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeam(teamCreateRequest: TeamCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Team>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeam(teamCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.createTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Удалить команду своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Удалить команду
         * @param {number} id ID команды
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeam(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeam(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.deleteTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить информацию о команде своей компании по ID. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить команду по ID
         * @param {number} id ID команды
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeam(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Team>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeam(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.getTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получение списка всех пользователей команды, в которой состоит указанный пользователь. Доступен только для роли: admin. Возвращает основную информацию о пользователях: имя, фамилия, почта, роль. 
         * @summary Получить список пользователей команды по ID пользователя
         * @param {number} userId ID пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamUsersByUserId(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserSummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamUsersByUserId(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.getTeamUsersByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получение списка всех пользователей команды с основной информацией. Доступен только для роли: admin. Возвращает основную информацию о пользователях: имя, фамилия, почта, роль. 
         * @summary Получить список пользователей команды
         * @param {number} id ID команды
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamUsersList(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserSummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamUsersList(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.getTeamUsersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить список команд своей компании с возможностью фильтрации и пагинации. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить список команд
         * @param {string} [search] Поиск по названию или описанию команды
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTeams(search?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTeams(search, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.listTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Обновить информацию о команде своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Обновить команду
         * @param {number} id ID команды
         * @param {TeamPatchRequest} teamPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchTeam(id: number, teamPatchRequest: TeamPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Team>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchTeam(id, teamPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.patchTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Удаляет пользователя из команды
         * @summary Удалить пользователя из команды
         * @param {number} id ID команды
         * @param {number} userId ID пользователя для удаления из команды
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUserFromTeam(id: number, userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUserFromTeam(id, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.removeUserFromTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamsApi - factory interface
 * @export
 */
export const TeamsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamsApiFp(configuration)
    return {
        /**
         * Добавляет пользователя в команду
         * @summary Добавить пользователя в команду
         * @param {number} id ID команды
         * @param {AddUserToTeamRequest} addUserToTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserToTeam(id: number, addUserToTeamRequest: AddUserToTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSummary> {
            return localVarFp.addUserToTeam(id, addUserToTeamRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Создать команду в своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Создать команду
         * @param {TeamCreateRequest} teamCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam(teamCreateRequest: TeamCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Team> {
            return localVarFp.createTeam(teamCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Удалить команду своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Удалить команду
         * @param {number} id ID команды
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTeam(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить информацию о команде своей компании по ID. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить команду по ID
         * @param {number} id ID команды
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Team> {
            return localVarFp.getTeam(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Получение списка всех пользователей команды, в которой состоит указанный пользователь. Доступен только для роли: admin. Возвращает основную информацию о пользователях: имя, фамилия, почта, роль. 
         * @summary Получить список пользователей команды по ID пользователя
         * @param {number} userId ID пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamUsersByUserId(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserSummary>> {
            return localVarFp.getTeamUsersByUserId(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Получение списка всех пользователей команды с основной информацией. Доступен только для роли: admin. Возвращает основную информацию о пользователях: имя, фамилия, почта, роль. 
         * @summary Получить список пользователей команды
         * @param {number} id ID команды
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamUsersList(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserSummary>> {
            return localVarFp.getTeamUsersList(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить список команд своей компании с возможностью фильтрации и пагинации. Изоляция данных происходит автоматически через JWT токен.
         * @summary Получить список команд
         * @param {string} [search] Поиск по названию или описанию команды
         * @param {number} [page] Номер страницы
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeams(search?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponse> {
            return localVarFp.listTeams(search, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Обновить информацию о команде своей компании. Изоляция данных происходит автоматически через JWT токен.
         * @summary Обновить команду
         * @param {number} id ID команды
         * @param {TeamPatchRequest} teamPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTeam(id: number, teamPatchRequest: TeamPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Team> {
            return localVarFp.patchTeam(id, teamPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Удаляет пользователя из команды
         * @summary Удалить пользователя из команды
         * @param {number} id ID команды
         * @param {number} userId ID пользователя для удаления из команды
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromTeam(id: number, userId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeUserFromTeam(id, userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamsApi - object-oriented interface
 * @export
 * @class TeamsApi
 * @extends {BaseAPI}
 */
export class TeamsApi extends BaseAPI {
    /**
     * Добавляет пользователя в команду
     * @summary Добавить пользователя в команду
     * @param {number} id ID команды
     * @param {AddUserToTeamRequest} addUserToTeamRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public addUserToTeam(id: number, addUserToTeamRequest: AddUserToTeamRequest, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).addUserToTeam(id, addUserToTeamRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Создать команду в своей компании. Изоляция данных происходит автоматически через JWT токен.
     * @summary Создать команду
     * @param {TeamCreateRequest} teamCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public createTeam(teamCreateRequest: TeamCreateRequest, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).createTeam(teamCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Удалить команду своей компании. Изоляция данных происходит автоматически через JWT токен.
     * @summary Удалить команду
     * @param {number} id ID команды
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public deleteTeam(id: number, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).deleteTeam(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить информацию о команде своей компании по ID. Изоляция данных происходит автоматически через JWT токен.
     * @summary Получить команду по ID
     * @param {number} id ID команды
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public getTeam(id: number, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).getTeam(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получение списка всех пользователей команды, в которой состоит указанный пользователь. Доступен только для роли: admin. Возвращает основную информацию о пользователях: имя, фамилия, почта, роль. 
     * @summary Получить список пользователей команды по ID пользователя
     * @param {number} userId ID пользователя
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public getTeamUsersByUserId(userId: number, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).getTeamUsersByUserId(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получение списка всех пользователей команды с основной информацией. Доступен только для роли: admin. Возвращает основную информацию о пользователях: имя, фамилия, почта, роль. 
     * @summary Получить список пользователей команды
     * @param {number} id ID команды
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public getTeamUsersList(id: number, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).getTeamUsersList(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить список команд своей компании с возможностью фильтрации и пагинации. Изоляция данных происходит автоматически через JWT токен.
     * @summary Получить список команд
     * @param {string} [search] Поиск по названию или описанию команды
     * @param {number} [page] Номер страницы
     * @param {number} [size] Размер страницы
     * @param {string} [sort] Поле для сортировки
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public listTeams(search?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).listTeams(search, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Обновить информацию о команде своей компании. Изоляция данных происходит автоматически через JWT токен.
     * @summary Обновить команду
     * @param {number} id ID команды
     * @param {TeamPatchRequest} teamPatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public patchTeam(id: number, teamPatchRequest: TeamPatchRequest, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).patchTeam(id, teamPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Удаляет пользователя из команды
     * @summary Удалить пользователя из команды
     * @param {number} id ID команды
     * @param {number} userId ID пользователя для удаления из команды
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public removeUserFromTeam(id: number, userId: number, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).removeUserFromTeam(id, userId, options).then((request) => request(this.axios, this.basePath));
    }
}



